


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const oshot: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} = {
    "en": {
        "url": "o-shot-treatment",
        "meta": {
            "title": "O Shot Treatment Dubai | Elite Body Home",
            "description": "Non-surgical O Shot treatment using PRP to enhance sexual health, improve intimacy, and address vaginal health issues like dryness and incontinence.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/o-shot-treatment/",
            "og": {
                "title": "O Shot Treatment Dubai | Elite Body Home",
                "description": "PRP therapy for enhanced sexual health and vaginal rejuvenation",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "O Shot Treatment"],
        "hero": {
            "title": "O Shot Treatment Dubai",
            "subtitle": "Enhance Sexual Health & Intimacy",
            "description": "The O Shot treatment is a breakthrough technology that helps women boost sexual health, intimacy, and solve various vaginal health problems. Stimulates tissue regeneration, increases sensation, enhances lubrication — this non-surgical method is the art of using your own platelet-rich plasma (PRP) from your blood. This revolutionary therapy can vastly improve the lives of women who struggle with issues like vaginal dryness, reduced sexual desire, or mild urinary incontinence."
        },
        "howItWorks": {
            "title": "Procedure for the O Shot",
            "description": "The O Shot is an in-office, non-invasive, quick procedure, often taking less than an hour. The injection of platelet-rich plasma into specific areas promotes the body's natural healing process."
        },
        "procedureSteps": {
            "heading": "Treatment Process",
            "para": "Our O Shot procedure involves several careful steps to ensure safety and effectiveness:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "It all starts with a consultation to determine your individual needs, medical history, and whether you are a good candidate for the O-Shot. It is also when you can ask for any questions and outcomes that will be had.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation",
                    "desc": "Just a small amount of blood is taken out from a vein and then broken up using a centrifuge so that the Platelet-Rich Plasma or PRP can be isolated; it is the part of the blood that contains growth factors involved in healing and rebuilding the tissues.",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "Numbing",
                    "desc": "Anesthetic numbing cream (topical) or local anesthetic is applied the area of injection to ensure the patient does not experience any discomfort during the procedure session.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "PRP Injection",
                    "desc": "PRP is injected into specific sites of the vagina, including near the clitoris and G-spot, to improve sensitivity, increase blood flow, and encourage tissue regeneration.",
                    "icon": "fa-solid fa-syringe"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of O Shot for Women",
            "subheading": "Enhancing sexual health and well-being",
            "para": "The O Shot treatment has a great deal of advantages to women looking to better their sexual health and well-being. The therapeutic interventions give physical and emotional benefits, you get intimacy and quality of life.",
            "items": [
                {
                    "title": "Increased sexual desire",
                    "desc": "The O Shot can increase women's drive, and sensitivity.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Improved vaginal lubrication",
                    "desc": "The therapy increases natural moisture, addressing vaginal dryness.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Enhanced orgasm intensity",
                    "desc": "Many women say they experience stronger, more satisfying orgasms.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "Reduced urinary incontinence",
                    "desc": "The O Shot may assist in tightening vaginal tissues which will decrease light urinary leakage.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "The O Shot is a great option for women ages 20 to 69 that are looking for other treatment to sexual health and vaginal health issues. However, there are some factors that will decide if you are an ideal candidate.",
            "items": [
                {
                    "title": "Women with low sexual desire",
                    "desc": "If you've noticed a decline in libido or sexual satisfaction, the O Shot may be for you.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Vaginal dryness",
                    "desc": "For women who suffer from painful intercourse due to insufficient natural lubrication, this procedure can bring moisture back.",
                    "icon": "fa-solid fa-hand-holding-water"
                },
                {
                    "title": "Mild urinary incontinence",
                    "desc": "Women with stress urinary incontinence or mild issues with bladder control can also potentially benefit from the O Shot.",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "Post-menopausal women",
                    "desc": "Yet women who are going through menopause might undergo vaginal health changes that can make them good candidates for the O Shot.",
                    "icon": "fa-solid fa-user-clock"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Before receiving the O Shot treatment, there are some simple preparations that can be done ahead of time to help increase the success rate. With proper preparation, you will have a smooth experience and optimal outcomes.",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "Talk with your provider at length about your symptoms, concerns and what you expect. They'll determine if the O Shot is appropriate for you.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Avoid blood thinners",
                    "desc": "It is recommended to refrain from blood-thinning medications or supplements, like aspirin, for a week before the procedure since these can increase bleeding and affect the efficacy of the platelet-rich plasma (PRP) treatment.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Hydrate",
                    "desc": "Hydrate well before your appointment to ensure easy blood draw and improve plasma quality.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Wear comfortable clothing",
                    "desc": "Wear loose, comfortable clothing on the day of your treatment for easy access during the procedure.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "O Shot for Sexual Health and Vaginal Rejuvenation - Temporo-Long-term Results The treatment is shown to have various positive results for women, ranging from better physical functionality to psychological effects.",
            "items": [
                {
                    "title": "Enhanced sexual sensation",
                    "desc": "Women usually report heightened sensitivity and more powerful orgasms.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "More natural lubrication",
                    "desc": "Many women find intercourse more comfortable, with less dryness.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Improved vaginal health",
                    "desc": "The process promotes new tissue to develop for healthier and more youthful vaginal skin.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Boosted confidence",
                    "desc": "Whenever you can feel a little better, a little more confident and free in intimate situations, it will improve quality of life overall.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain and prolong your results:",
            "items": [
                {
                    "title": "Avoid strenuous activity",
                    "desc": "Refrain from vigorous exercise for 24-48 hours after the procedure.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Skip sexual activity",
                    "desc": "Avoid intercourse for at least 48 hours post-treatment.",
                    "icon": "fa-solid fa-heart-slash"
                },
                {
                    "title": "Maintain hygiene",
                    "desc": "Keep the area clean but avoid harsh soaps or douching.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "Follow up",
                    "desc": "Attend any recommended follow-up appointments for optimal results.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is the O Shot treatment safe?",
                    "answer": "Yes, when performed by qualified professionals using your own PRP, the O Shot is considered safe with minimal risks."
                },
                {
                    "question": "How many sessions will I need?",
                    "answer": "Most patients see results after one session, though some may benefit from 2-3 treatments spaced 4-6 weeks apart for optimal results."
                },
                {
                    "question": "Does the treatment hurt?",
                    "answer": "Most patients report minimal discomfort during the procedure thanks to the numbing cream applied beforehand."
                },
                {
                    "question": "How long do results last?",
                    "answer": "Results typically last 12-18 months, with maintenance treatments recommended annually."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Possible temporary side effects may include mild swelling or tenderness, which typically resolves within 24-48 hours."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/o-shot-in-dubai-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 160,
            "title": "O Shot Treatment in Dubai",
            "description": "PRP therapy for enhanced sexual health, improved intimacy and vaginal rejuvenation.",
            "price": 1200
        }
    },
    "ar": {
        "url": "o-shot-treatment",
        "meta": {
            "title": "حقن أو شوت في دبي | ايليت بودي هوم",
            "description": "علاج أو شوت باستخدام البلازما الغنية بالصفائح الدموية لتعزيز الصحة الجنسية وتحسين العلاقة الحميمة وعلاج مشاكل صحة المهبل.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/o-shot-treatment",
            "og": {
                "title": "حقن أو شوت في دبي | ايليت بودي هوم",
                "description": "علاج بالبلازما الغنية بالصفائح الدموية لتعزيز الصحة الجنسية وتجديد أنسجة المهبل",
                "image": "https://www.elitebodyhome.com/images/o-shot-treatment-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "حقن أو شوت"],
        "hero": {
            "title": "حقن أو شوت في دبي",
            "subtitle": "تعزيز الصحة الجنسية والعلاقة الحميمة",
            "description": "يُعد علاج أو شوت حلاً ثورياً يهدف إلى تعزيز الصحة الجنسية للمرأة، وتحسين العلاقة الحميمة، وعلاج مشكلات متعددة تتعلق بصحة المهبل. يعتمد هذا الإجراء غير الجراحي على حقن البلازما الغنية بالصفائح الدموية (PRP) المستخلصة من دمكِ، لتحفيز تجديد الأنسجة، وتعزيز الإثارة، وتحسين الترطيب الطبيعي. يمكن أن تستفيد النساء اللواتي يعانين من الجفاف المهبلي، أو انخفاض الرغبة الجنسية، أو سلس البول الخفيف من هذا العلاج المبتكر."
        },
        "howItWorks": {
            "title": "خطوات إجراء علاج أو شوت",
            "description": "يُعد علاج أو شوت علاج بسيط وغير جراحي يُنفذ خلال أقل من ساعة، ويعتمد على حقن البلازما الغنية بالصفائح الدموية في مناطق محددة لتحفيز التجديد الطبيعي للأنسجة."
        },
        "procedureSteps": {
            "heading": "خطوات العلاج",
            "para": "يتضمن إجراء أو شوت عدة خطوات لضمان السلامة والفعالية:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يبدأ الإجراء بجلسة استشارية لتقييم احتياجاتك الفردية، وتاريخك الطبي، ولمعرفة مدى ملاءمتك للعلاج، كما يمكنك في هذه المرحلة طرح جميع استفساراتك والتعرف على النتائج المتوقعة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تُسحب عينة صغيرة من الدم ثم تُعالج باستخدام جهاز الطرد المركزي لعزل البلازما الغنية بالصفائح الدموية، والتي تحتوي على عوامل نمو تساعد في ترميم وتجديد الأنسجة.",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "التخدير",
                    "desc": "يُستخدم كريم موضعي أو مخدر موضعي على منطقة الحقن لضمان شعورك بالراحة التامة طوال فترة الإجراء.",
                    "icon": "fa-solid fa-spray-can"
                },
                {
                    "title": "حقن البلازما الغنية بالصفائح الدموية",
                    "desc": "تُحقن البلازما في مناطق محددة داخل المهبل مثل حول البظر والجي سبوت، لتعزيز الإثارة، وتنشيط الدورة الدموية، وتحفيز تجديد الأنسجة.",
                    "icon": "fa-solid fa-syringe"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد علاج أو شوت للنساء",
            "subheading": "تعزيز الصحة الجنسية والعامة",
            "para": "توفر حقن بلازما أو شوت مجموعة من الفوائد المهمة للنساء اللواتي يرغبن في تعزيز صحتهن الجنسية والعامة. يساعد هذا العلاج في تحقيق تحسن جسدي ونفسي، مما ينعكس إيجابًا على العلاقة الحميمة وجودة الحياة.",
            "items": [
                {
                    "title": "زيادة الرغبة الجنسية",
                    "desc": "تلاحظ معظم النساء بعد العلاج زيادة الرغبة الجنسية وتحسن الإثارة.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "تحسين ترطيب المهبل",
                    "desc": "يساعد على تعزيز الترطيب الطبيعي للمهبل والتقليل من جفافه.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "زيادة شدة النشوة",
                    "desc": "أفادت العديد من النساء بزيادة المتعة الجنسية وشدة النشوة ورضاهن بعد العلاج.",
                    "icon": "fa-solid fa-star"
                },
                {
                    "title": "التقليل من سلس البول",
                    "desc": "يساهم في تقوية أنسجة المهبل، مما يخفف من حالات سلس البول البسيط.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يُعد علاج أو شوت خيارًا مثاليًا للعديد من النساء اللواتي يعانين من مشكلات شائعة تتعلق بالصحة الجنسية وصحة المهبل. ومع ذلك، توجد عوامل محددة تساعد في تحديد ما إذا كنتِ مرشحة مثالية لهذا العلاج.",
            "items": [
                {
                    "title": "انخفاض الرغبة الجنسية",
                    "desc": "إذا لاحظتِ تراجعًا في الرغبة أو الرضا الجنسي، فيمكن أن يساعدك هذا العلاج.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "الجفاف المهبلي",
                    "desc": "تساعد حقن أو شوت للنساء اللواتي يعانين من ألم أثناء العلاقة بسبب نقص الترطيب الطبيعي، حيث يعمل على استعادة الترطيب.",
                    "icon": "fa-solid fa-hand-holding-water"
                },
                {
                    "title": "سلس البول الخفيف",
                    "desc": "يمكن أن يكون علاج أو شوت مفيدًا للنساء اللواتي يعانين من سلس البول الناتج عن الضغط أو من مشكلات خفيفة في التحكم بالمثانة.",
                    "icon": "fa-solid fa-procedures"
                },
                {
                    "title": "النساء بعد انقطاع الطمث",
                    "desc": "قد تؤثر التغيرات الهرمونية في مرحلة ما بعد انقطاع الطمث على صحة المهبل، مما يجعل النساء في هذه المرحلة مرشحات مناسبات للعلاج.",
                    "icon": "fa-solid fa-user-clock"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يُنصح باتباع بعض الخطوات التحضيرية البسيطة قبل الخضوع لعلاج أو شوت لضمان أفضل النتائج، حيث يساهم التحضير الجيد في تجربة سلسة ونتائج مثالية.",
            "items": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "ابدئي بجلسة استشارية مفصلة مع الطبيب لمناقشة الأعراض والمخاوف والتوقعات. سيتم تقييم ما إذا كان علاج أو شوت مناسبًا لحالتك.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "تجنب مميعات الدم",
                    "desc": "يُنصح بالتوقف عن تناول الأدوية أو المكملات الغذائية التي تُرقق الدم مثل الأسبرين قبل أسبوع من الجلسة، لأنها قد تؤثر على فاعلية البلازما الغنية بالصفائح الدموية.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "اشربي كميات كافية من الماء قبل موعدك لضمان سهولة سحب عينة الدم وتحسين جودة البلازما المستخلصة.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "ارتدِ ملابس مريحة",
                    "desc": "اختاري ملابس فضفاضة ومريحة في يوم الجلسة لتسهيل الوصول إلى منطقة العلاج دون إزعاج.",
                    "icon": "fa-solid fa-tshirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يوفر علاج أو شوت نتائج طويلة الأمد في تحسين الصحة الجنسية وتجديد المنطقة الحميمة، ويضمن لكِ مجموعة متنوعة من التحسينات التي تؤثر بشكل إيجابي على الأداء الجسدي والصحة النفسية.",
            "items": [
                {
                    "title": "تحسين التجربة الجنسية",
                    "desc": "تُبلغ العديد من النساء عن زيادة في الإثارة الجنسية وشعور أقوى خلال النشوة.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "زيادة الترطيب الطبيعي",
                    "desc": "تشعر العديد من النساء براحة أكبر أثناء العلاقة الحميمة بعد الخضوع لعلاج أو شوت.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "تحسين الصحة المهبلية",
                    "desc": "يساهم تجديد الأنسجة في تحسين مظهر وملمس الجلد، مما يمنحه مظهراً أكثر شباباً.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "مع الشعور بالراحة والثقة خلال العلاقة، تلاحظ الكثير من النساء تحسناً في جودة حياتهن بشكل عام.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للمحافظة على النتائج وإطالة أمدها:",
            "items": [
                {
                    "title": "تجنب النشاط المجهد",
                    "desc": "امتنعي عن ممارسة التمارين القوية لمدة 24-48 ساعة بعد الإجراء.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "تجنب العلاقة الحميمة",
                    "desc": "تجنبي الجماع لمدة 48 ساعة على الأقل بعد العلاج.",
                    "icon": "fa-solid fa-heart-slash"
                },
                {
                    "title": "الحفاظ على النظافة",
                    "desc": "حافظي على نظافة المنطقة ولكن تجنبي استخدام الصابون القاسي أو الدوش المهبلي.",
                    "icon": "fa-solid fa-pump-soap"
                },
                {
                    "title": "المتابعة",
                    "desc": "احرصي على حضور جلسات المتابعة الموصى بها للحصول على أفضل النتائج.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل علاج أو شوت آمن؟",
                    "answer": "نعم، عند إجرائه من قبل متخصصين مؤهلين باستخدام البلازما الغنية بالصفائح الدموية الخاصة بك، يعتبر علاج أو شوت آمنًا مع مخاطر محدودة."
                },
                {
                    "question": "كم جلسة أحتاج للحصول على النتائج؟",
                    "answer": "معظم المريضات يلاحظن النتائج بعد جلسة واحدة، بينما قد يستفدن بعضهن من 2-3 جلسات بفاصل 4-6 أسابيع للحصول على نتائج مثالية."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "معظم المريضات يذكرن شعورًا بسيطًا بعدم الراحة أثناء الإجراء بفضل الكريم المخدر الذي يتم تطبيقه مسبقًا."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "تدوم النتائج عادةً من 12 إلى 18 شهرًا، مع توصية بجلسات صيانة سنوية."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد تشمل الآثار الجانبية المؤقتة تورمًا خفيفًا أو ألمًا بسيطًا، والذي يختفي عادةً خلال 24-48 ساعة."
                }
            ]
        }
    }
}